import { injectable } from 'inversify'

import { StoreBase } from '@writefull/core'

export interface ModalsStoreState {
  isSignInOpen: boolean
}

export interface ModalsStoreActions {
  openSignIn: () => void
  closeSignIn: () => void
}

const initialState: ModalsStoreState = {
  isSignInOpen: false,
}

const actions = (
  set: (fn: (state: ModalsStoreState) => ModalsStoreState) => void,
): ModalsStoreActions => ({
  openSignIn: () => set((s) => ({ ...s, isSignInOpen: true })),
  closeSignIn: () => set((s) => ({ ...s, isSignInOpen: false })),
})

@injectable()
export class ModalsStore extends StoreBase<ModalsStoreState, ModalsStoreActions> {
  constructor() {
    super(initialState, actions)
  }
}

export const modalsStore = new ModalsStore()
const useModalsStore = modalsStore.getStore()
export default useModalsStore
